module.exports = __webpack_public_path__ + "static/media/viet1.ae5d0b39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/viet1.jpg
// module id = 432
// module chunks = 0